import { FC, useState } from 'react';
import { WrapInLayout } from '../layouts';
import { orderApi } from '../api/order.api';
import OrdersCategoryList from '../components/orders/OrdersCategoryList';
import OrdersDrilldownModal from '../components/orders/OrdersDrilldownModal';
import { DRILLDOWN_BY_STATUS, SUMMARY_BY_STATUS } from '../components/orders/categoryColumns';
import { IDateRange, presetRange } from '../components/orders/orderDatePresets';

const OrdersByStatusPage: FC = () => {
  const [range, setRange] = useState<IDateRange>(() => presetRange('month'));

  const { data, isFetching, isError, error } = orderApi.useGetOrdersByStatusQuery({
    createdFrom: range.createdFrom,
    createdTill: range.createdTill,
  });

  return (
    <WrapInLayout title="Orders By Status" layout="dashboard">
      <h1 className="text-xl font-semibold mb-3">Orders By Status</h1>
      <OrdersCategoryList
        categoryTitle="status"
        columns={SUMMARY_BY_STATUS}
        unit="status(es)"
        resizeStorageKey="orders-by-status"
        rows={data}
        isFetching={isFetching}
        isError={isError}
        error={error}
        range={range}
        onRangeChange={setRange}
        renderDrilldown={(row, close) => (
          <OrdersDrilldownModal
            title={`Orders with status ${row.category}`}
            columns={DRILLDOWN_BY_STATUS}
            createdFrom={range.createdFrom}
            createdTill={range.createdTill}
            status={row.category}
            onClose={close}
          />
        )}
      />
    </WrapInLayout>
  );
};

export default OrdersByStatusPage;
